import React, { Component } from 'react';
import { Box } from '@mui/material'

export type LayoutProps = {
  children?: JSX.Element
}

const Layout = (props: LayoutProps) => (
  <Box className="app-layout">
    {props.children}
  </Box>
)

export default Layout